import moment from 'moment';
import {mapActions} from "vuex";
/*
使用方法
1.import {myMixin} from '@/mixins/tool.js'
2.mixins:[myMixin]
*/
export const myMixin ={
    provide() {
        return {
            initData:this.initData,
            getDataSource:this.getDataSource,
            //时间戳转换为描述性时间
            getDays: this.getDays,
            //时间转换成时间戳
            getSeconds:this.getSeconds,
            //时间戳转换成标准时间格式 YYYY-MM-DD
            getLocalTime:this.getLocalTime,
            //时间戳转换成标准时间格式 YYYY-MM-DD hh:mm
            getDetailTime:this.getDetailTime,
            //时间戳转换成整天数
            getDaysNum:this.getDaysNum,
            //返回当天23:59:59的时间戳
            getLastTime:this.getLastTime,
            //自动判断终端然后链接跳转,toUri(item.uri,'yes')先跳预览
            toUri:this.toUri,
            rootpath:this.rootpath,
            reload:this.reload,
            isPage:this.isPage,
            routeName:this.routeName,
            getApps:this.getApps,
            backtotopNow:this.backtotopNow,
            getQueryString:this.getQueryString,
            userLoaded:this.userLoaded,
            isWxwork:this.isWxwork
        }
    },
    created() {
        document.title = "紫荆e站办事服务大厅";
    },
    mounted(){
        let self = this;
        document.addEventListener("DOMContentLoaded", function(event) {
            self.sdk_start.push(1);
        });
        this.logoutTime(); //超时登出
    },
    data(){
        return{
            RouterShow:true,
            userProfile:{},
            sdk_start:[]
        }
    },
    watch:{
        sdk_start:{
            handler(val,oldval){
                if(val.length>1){
                    let self = this;
                    const s = document.createElement('script');
                    s.type = 'text/javascript';
                    s.src = `${location.origin}/infoplus/static/js/sdk/infoplus.sdk.js`;
                    // s.src = "https://cloud.ketanyun.cn/infoplus/static/js/sdk/infoplus.sdk.js";
                    document.body.appendChild(s);

                    if(s.readyState){
                        s.onreadystatechange=function(){
                            if(s.readyState=='complete'||s.readyState=='loaded'){
                                s.onreadystatechange=null;
                                var check = InfoPlusSDK.checkBrowser();
                                if(!check){
                                    return false;
                                }else{
                                    var apiMessageUrl= `${location.origin}/infoplus/message/sub`;
                                    InfoPlusSDK.message.create(self.userProfile.id, apiMessageUrl).sub("task", function(message){
                                        if(self.isCanRefresh){
                                            self.reloadInfoNum();
                                            self.initData();
                                            self.reload();
                                        }
                                    });
                                }
                                console.log('check',check);
                            }
                        }
                    }else{
                        s.onload=function(){
                            var check = InfoPlusSDK.checkBrowser();
                            if(!check){
                                return false;
                            }else{
                                var apiMessageUrl= `${location.origin}/infoplus/message/sub`;
                                InfoPlusSDK.message.create(self.userProfile.id, apiMessageUrl).sub("task", function(message){
                                    if(self.isCanRefresh){
                                        self.reloadInfoNum();
                                        self.initData();
                                        self.reload();
                                    }
                                });
                            }
                            console.log('check',check);
                        }
                    }
                }
            },
            deep:true
        },
        targetMessage:{
            handler(val,oldval){
                if(val!=oldval){
                    let key = val.split('#');
                    this.$message[key[0]](key[1]);
                }
            },
            deep:true
        },
        getAuth:{
            handler(val,oldval){
                this.userLoaded();
            },
            deep:true
        },
    },
    methods:{
        moment,
        ...mapActions("oidcStore", ["signOutOidc"]),
        logoutTime() {
            let that = this;
            let lastTime = new Date().getTime();
            let currentTime = new Date().getTime();
            //设置超时时间： 3小时
            let timeOut = 10800000;
            window.onload = () => {
                document.addEventListener("mousemove", () => {
                    lastTime = new Date().getTime();
                });
            };
            var quitTime = window.setInterval(testTime, 5400000);

            function testTime() {
                currentTime = new Date().getTime();
                if (currentTime - lastTime >= timeOut) {
                    that.signOutOidc();
                    window.clearInterval(quitTime);
                }
            }
        },
        isPage(str){
            if(this.$route.name === str){
                return true;
            }else{
                return false;
            }
        },
        reloadInfoNum(){
            this.$store.dispatch('metodoLength');
            this.$store.dispatch('ccsLength');
            if(this.todoBoolean){
                this.$store.dispatch('metodoLength',this.todoBoolean);
            }
        },
        backtotopNow(){
            this.$refs.ScrollTop.scrollToTop();
        },
        reload(){
            this.RouterShow = false;
            this.$nextTick(function () {
                this.RouterShow = true;
            });
        },
        getMobile() {
            var flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            if (flag === null) {
                return false;
            } else {
                return true;
            }
        },
        getQueryString(name,nowHref){
            if(location.href || nowHref){
                let hrefStr = location.href || nowHref;
                if(hrefStr.split("?").length > 1){
                    hrefStr = hrefStr.split("?")[1];
                    let paramsArr = hrefStr.split('&');
                    let paramsObj = {};
                    for(let i in paramsArr){
                        let miniArr = paramsArr[i].split("=");
                        let ikey = miniArr[0];
                        miniArr.shift();
                        let ival = miniArr.join("");
                        paramsObj[ikey] = ival;
                    }
                    console.log(paramsObj);
                    return paramsObj[name];
                }
            }else{
                return null;
            }
        },
        userLoaded(e){
            this.getProfile();
            this.getApps();
        },

        getApps(){
            let filterApps = null;
            if(this.appsFilter){
                filterApps = this.appsFilter;
            }
            this.$store.dispatch('fetchAppList',{filterApps});
            //暴露一个参数如果是机器人模式，则去拿另一个接口的apps
            if(this.hasRobot){
                window.aiDialog.createRobot();
                this.$store.dispatch('manageApp/getSearchResult',{seq:''});
            }
            let user = this.$store.getters.getEmail;
            if(!localStorage.getItem(`${user}_top`)){
                localStorage.setItem(`${user}_top`,'start');
            }
        },
        getLastTime(){
            let time = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
            let seconds = moment(time).valueOf() - 1;
            return seconds;
        },
        getDays(time){
            let minute = (moment(new Date().getTime()).diff(moment(time*1000), 'minute'))
            let hour = (moment(new Date().getTime()).diff(moment(time*1000), 'hour'))
            let day = (moment(new Date().getTime()).diff(moment(time*1000), 'day'))
            let month = (moment(new Date().getTime()).diff(moment(time*1000), 'month'))
            let year = (moment(new Date().getTime()).diff(moment(time*1000), 'year'))
            if(minute<60){
                return `${minute+1}分钟前`
            }else if(hour<24){
                return  `${hour}小时前`
            }else if(day<30){
                return `${day}天前`
            }else if(month<12){
                return `${month}月前`
            }else{
                return `${year}年前`
            }
        },
        getDetailTime(time){
            let timeStr = moment(time*1000).format('YYYY-MM-DD hh:mm');
            return timeStr;
        },
        getDaysNum(time) {
            let day = moment(new Date().getTime()).diff(moment(time * 1000), "day");
            return `${day}天`;
        },
        rootpath(){
            return "@/assets/todoCenter/default/images";
        },
        routeName(){
            return this.$route.name;
        },
        getSeconds(time){
            let seconds = moment(time).valueOf();
            return seconds
        },
        getLocalTime(time){
            let timeStr = moment(time*1000).format('YYYY-MM-DD');
            return timeStr;
        },
        initData(route,bool){
            let dataName = route || this.$route.name;
            if(dataName === 'apply'){
                dataName = 'todo';
            }
            let obj = {};
            obj.dataName = dataName;
            if(bool){
                obj.limitRefresh = true;
            }
            this.$store.dispatch('ClearQ',obj);
        },
        getDataSource(name){
            let dataName = name || this.$route.name;
            if(dataName === 'apply'){
                dataName = 'todo';
            }
            return this.$store.getters.getDataSource[dataName];
        },
        isWxwork: function () {
            let flag = navigator.userAgent.match(/(wxwork)/i);
            if (flag === null) {
                return false;
            } else {
                return true;
            }
        },
        toUri( appUrl , preview, remark){
            var isMobile = false;
            var flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            if (flag != null) {
                isMobile = true;
            }
            let query = {};
            if(isMobile){
                query.back = 1;
                query.x_posted = true;
            }

            if(remark === true || remark === false){
                query.showRemark = remark;
            }

            if(preview){
                if(appUrl.indexOf('preview')===-1){
                    query.preview = preview === 'yes'?true:false;
                }else{
                    if(preview === 'yes'){
                        appUrl = appUrl.replace("preview=false","preview=true")
                    }else{
                        appUrl = appUrl.replace("preview=true","preview=false")
                    }
                }
            }
            let len = Object.keys(query).length;
            if(len>0){
                let after_url = '';
                let i = 1;
                for(let key in query){
                    after_url = i<len?after_url+`${key}=${query[key]}&`:after_url+`${key}=${query[key]}`;
                    i++;
                }
                if(appUrl.indexOf("?")>-1) {
                    appUrl += "&" + after_url;
                }else{
                    appUrl += "?" + after_url;
                }

            }
            if(isMobile){
                location.href = appUrl;
            }else{
                window.open(appUrl);
            }
        },
        async getProfile(){
            var self = this;
            await this.$axios.get(`${window.commonApi.INFOPLUS_URL}/me/profile`).then((res)=>{
                if (res.data.errno === 0 ) {
                    self.userProfile=res.data.entities[0];
                    self.$store.commit('setUserInfo',self.userProfile);
                    self.sdk_start.push(1);
                }
            }).catch(error => {
                console.log(error); //请求失败返回的数据
            });
        },
    },
    computed:{
        getAuth(){
            return this.$store.getters.getAuth.access_token
        },
        membership(){
            return sessionStorage.getItem('membership') || this.getQueryString('membership');
        },
        isCanRefresh(){
            return this.$store.getters.getState.isCanFresh;
        },
        targetMessage(){
            return this.$store.getters.getState.targetMessage;
        }
    }
}




// WEBPACK FOOTER //
// ./src/mixins/tool.js